export default class InputStorage {
  constructor(helpSection) {
    this._helpSection = helpSection;
    window.addEventListener('unload', () => {
      const inputs = document.querySelectorAll('input[type="text"],input[type="number"],input[type="checkbox"],input[type="range"],select,input[type="radio"]:checked');
      inputs.forEach(input => {
        if(InputStorage.hasKeyRecursively(input, 'save')) {
          if(input.type === 'checkbox') {
            localStorage[input.name] = input.checked ? 1 : 0;
          } else {
            localStorage[input.name] = input.value;
          }
        }
      });
      localStorage.helpSectionVisible = this._helpSection.visible;
    });
  }
  init() {
    document.querySelectorAll('input[type="text"],input[type="number"],input[type="checkbox"],input[type="range"],select').forEach(input => {
      if(InputStorage.hasKeyRecursively(input, 'init')) {
        console.assert(input.name, input);
        const value = localStorage[input.name];
        if(value != undefined) {
          if(input.type === 'checkbox') {
            input.checked = parseInt(value);
          } else if(input.type !== 'radio') {
            input.value = value;
          }
        }
        input.dispatchEvent(new Event('input', {bubbles: true}));
      }
    });
    document.querySelectorAll('input[type="radio"]').forEach(input => {
      if(InputStorage.hasKeyRecursively(input, 'init')) {
        console.assert(input.name, input);
        const value = localStorage[input.name];
        if(value != undefined) {
          if(input.value === value) {
            input.checked = true;
            input.dispatchEvent(new Event('input', {bubbles: true}));
          }
        }
      }
    });
    if(localStorage.baseSize) {
      document.documentElement.style.setProperty('--base-size', localStorage.baseSize + 'px');
    }
    if(localStorage.helpSectionVisible != undefined) {
      this._helpSection.visible = localStorage.helpSectionVisible;
    } else {
      this._helpSection.visible = 1;
    }
  }
  static hasKeyRecursively(element, key) {
    if(element) {
      if(element.dataset[key] !== undefined) {
        return true;
      }
      return InputStorage.hasKeyRecursively(element.parentElement, key);
    }
    return false;
  }
}
